import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import moment from "moment-timezone";
import { Link } from "react-router-dom";
import { graphColor } from "../BreachConstants";
import { removePremiumBreachesByBreachId } from "../../../store/service";
import { Notification } from "../../common/Notification";

const TD = ({ children, style = {}, className }: any) => {
    return (
        <td className={className} style={{ color: "#00313c", ...style }}>
            {children}
        </td>
    );
};

const SavedBreachTableBody = ({
    rowBreachData,
    getNewData,
    setIsDeleteDialogOpen,
    setIsLoading,
    breachDetail,
    setBreachDetail,
    isRemoveCall,
    setIsRemoveCall,
    savedPage,
    titleNameSavedBreach,
    setSavedPage,
}: any) => {
    const [viewMore, setViewMore] = useState<any>(null);
    const history = useHistory();

    const handleRemove = () => {
        setIsLoading(true);
        setIsRemoveCall(false);
        removePremiumBreachesByBreachId({
            BreachIDs: [breachDetail.breachID],
            Source: 1,
        }).then((res) => {
            setIsLoading(false);
            if (res.isSuccess) {
                setIsDeleteDialogOpen(false);
                Notification({
                    type: "success",
                    title: "Remove Breach",
                    message: "Breach successfully removed.",
                });
                getNewData();
                setBreachDetail({ orgName: "", breachID: "" });
                if (savedPage !== 1) {
                    if (savedPage * 5 - 4 === rowBreachData.length) {
                        setSavedPage(savedPage - 1);
                    }
                }
            } else {
                Notification({
                    type: "error",
                    title: "Remove Breach",
                    message: "We are facing issue to remove breach, please try again later.",
                    duration: 5,
                });
            }
        });
    };

    const handleRedirect = (id: number, orgName: string, breachDate: any) => {
        history.push({
            pathname: `/breaches/breach-details`,
            state: { id, backPage: "breach_exposure", orgName, breachDate },
        });
    };

    useEffect(() => {
        if (rowBreachData.length) {
            let breachIdList = {};
            rowBreachData.forEach((item: any) => {
                breachIdList = { ...breachIdList, [item.breachId]: false };
            });
            setViewMore(breachIdList);
        }
    }, [rowBreachData.length]);

    useEffect(() => {
        if (isRemoveCall) {
            handleRemove();
        }
    }, [isRemoveCall]);

    let res = rowBreachData.length ? rowBreachData.slice(savedPage === 1 ? 0 : (savedPage - 1) * 5, savedPage * 5) : [];
    return res.length
        ? res.map((item: any, i: any) => {
              let affectedDataTypeList = JSON.parse(item.affectedDataTypes);
              return (
                  <tr key={item.breachId}>
                      <TD
                          className={
                              titleNameSavedBreach === "organization bold"
                                  ? "breach-organization border-top-bottom vertical-align-top highlight-exposure-table-body bold"
                                  : "breach-organization border-top-bottom vertical-align-top bold"
                          }
                      >
                          <div className="my-exposure-org-name bold" onClick={() => handleRedirect(item.breachId, item.organization, item.breachDate)}>
                              {item.organization}
                          </div>
                          <div className="show-exposure-col">{moment(item.breachDate).format("MM/YYYY")}</div>
                      </TD>

                      <TD
                          className={
                              titleNameSavedBreach === "breachDate"
                                  ? "border-top-bottom vertical-align-top highlight-exposure-table-body hide-exposure-col"
                                  : "border-top-bottom vertical-align-top hide-exposure-col"
                          }
                          style={{ padding: "1rem 10px 10px 10px" }}
                      >
                          {moment(item.breachDate).format("MM/YYYY")}
                      </TD>

                      <TD className="border-top-bottom vertical-align-middle hide-exposure-col">
                          <ul style={{ margin: "10px 1rem", fontSize: "0.75rem" }}>
                              {affectedDataTypeList.length &&
                                  affectedDataTypeList.map((listItem: string, index: number) => {
                                      if (index < 2 && viewMore && !viewMore[item.breachId]) {
                                          return (
                                              <li className="list-style-disc" key={`${index}-${listItem}`} style={{ paddingBottom: "0.3rem" }}>
                                                  <span style={{ lineHeight: 1.2 }}>{listItem}</span>
                                              </li>
                                          );
                                      } else if (viewMore && viewMore[item.breachId]) {
                                          return (
                                              <li className="list-style-disc" key={`${index}-${listItem}`} style={{ paddingBottom: "0.3rem" }}>
                                                  <span style={{ lineHeight: 1.2 }}>{listItem}</span>
                                              </li>
                                          );
                                      } else {
                                          return null;
                                      }
                                  })}
                              {affectedDataTypeList.length && affectedDataTypeList.length > 2 ? (
                                  viewMore && !viewMore[item.breachId] ? (
                                      <Link
                                          to="/"
                                          className="default_link"
                                          style={{ padding: "5px 0px" }}
                                          onClick={(e: any) => {
                                              e.preventDefault();
                                              setViewMore({ ...viewMore, [item.breachId]: true });
                                          }}
                                      >
                                          {`View ${affectedDataTypeList.length - 2} more data types`}
                                      </Link>
                                  ) : (
                                      <Link
                                          to="/"
                                          className="default_link"
                                          style={{ padding: "5px 0px" }}
                                          onClick={(e: any) => {
                                              e.preventDefault();
                                              setViewMore({ ...viewMore, [item.breachId]: false });
                                          }}
                                      >
                                          {`Collapse data types`}
                                      </Link>
                                  )
                              ) : null}
                          </ul>
                      </TD>
                      <TD
                          className={
                              titleNameSavedBreach === "breachRiskRating"
                                  ? "border-top-bottom input-card highlight-exposure-table-body"
                                  : "border-top-bottom input-card"
                          }
                      >
                          <div className="breach-exposure-risk-rating-card">
                              <div className="breach-exposure-score-card">
                                  <span className={`risk-score ${graphColor[item.score]["textColor"]}`}>{item.score}</span>

                                  <div className={`exposure-risk-score-card ${graphColor[item.score]["cardBg"]}`}>
                                      <span className={`risk-label ${graphColor[item.score]["textColor"]}`}>{graphColor[item.score]["text"]}</span>
                                      <span className={`risk-label-score ${graphColor[item.score]["textColor"]}`}>{`(${item.score} of 10)`}</span>
                                  </div>
                              </div>
                          </div>
                      </TD>
                      <TD
                          className={
                              titleNameSavedBreach === "breachRiskRating"
                                  ? "breach-risk-rating-table border-top-bottom vertical-align-top highlight-exposure-table-body"
                                  : "breach-risk-rating-table border-top-bottom vertical-align-top"
                          }
                          style={{ padding: "20px 0px" }}
                      >
                          <div className="new-detected-breach-text">
                              <button
                                  onClick={() => {
                                      setBreachDetail({
                                          orgName: item.organization,
                                          breachID: item.breachId.toString(),
                                      });
                                      setIsDeleteDialogOpen(true);
                                  }}
                                  className="header-button"
                                  aria-label={`Delete ${item.organization}` }
                              >
                              <em className="las la-trash delete-icon-breach" role="img" aria-label={`Delete ${item.organization} Breach`}></em>
                              </button>
                          </div>
                      </TD>
                  </tr>
              );
          })
        : <tr>
            <td role="cell" colspan="5"></td>
        </tr>;
};

export default SavedBreachTableBody;
